import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import useMountEffect from '../../../../utils/hooks/useMountEffect'
import { cloneDeep } from 'lodash'
import {
  defaultTemplate,
  checkConfigOption,
} from '../../../../utils/assetTypeConfigurations'

const AssetTypeDefaultForm = ({ configuration, handleUpdateConfiguration }) => {
  const { t } = useTranslation()
  const [defaultConfiguration, setDefaultConfiguration] = useState(
    cloneDeep(defaultTemplate)
  )

  useMountEffect(() => {
    setDefaultConfiguration(JSON.parse(configuration))
  })
  useEffect(() => {
    setDefaultConfiguration(JSON.parse(configuration))
  }, [configuration])

  const updateInputFields = (e) => {
    const { target } = e
    let key = target.id
    const keys = key.split('.')
    let value = null
    let newConfiguration = cloneDeep(defaultConfiguration)
    switch (key) {
      case 'responsiblePerson.option.mandatory':
      case 'responsiblePerson.option.enabled':
      case 'responsiblePerson.option.disabled':
      case 'timeSpan.option.mandatory':
      case 'timeSpan.option.enabled':
      case 'timeSpan.option.disabled':
      case 'comment.option.mandatory':
      case 'comment.option.enabled':
      case 'comment.option.disabled':
        value = keys[2]
        break
      default:
        if (target.type === 'checkbox') {
          value = target.checked
        } else {
          value = target.value
        }
        break
    }
    newConfiguration[keys[0]][keys[1]] = value
    setDefaultConfiguration(newConfiguration)
    handleUpdateConfiguration(JSON.stringify(newConfiguration))
  }
  return (
    <>
      <Form.Group className='mb-3'>
        <Form.Label>{t('assetTypes:number')}</Form.Label>
        <Form.Check
          type='checkbox'
          id='number.isUnique'
          label={t('assetTypes:isUnique')}
          checked={defaultConfiguration.number.isUnique}
          onChange={updateInputFields}
        />
      </Form.Group>
      <Form.Group className='mb-3'>
        <Form.Label>{t('assetTypes:numberRange')}</Form.Label>
        <Form.Control
          id='number.numberrange'
          name='number.numberrange'
          placeholder={t('assetTypes:numberRange')}
          value={defaultConfiguration.number.numberrange}
          onChange={updateInputFields}
        />
      </Form.Group>
      <Form.Group className='mb-3'>
        <Form.Label className='d-block ps-1'>
          {t('assetTypes:responsiblePerson')}
        </Form.Label>
        <Form.Check
          inline
          type='radio'
          id='responsiblePerson.option.mandatory'
          name='responsiblePerson.option.mandatory'
          label={t('assetTypes:optionMandatory')}
          checked={checkConfigOption(
            'mandatory',
            defaultConfiguration.responsiblePerson.option
          )}
          onChange={updateInputFields}
        />
        <Form.Check
          inline
          type='radio'
          id='responsiblePerson.option.enabled'
          name='responsiblePerson.option.enabled'
          label={t('assetTypes:optionEnabled')}
          checked={checkConfigOption(
            'enabled',
            defaultConfiguration.responsiblePerson.option
          )}
          onChange={updateInputFields}
        />
        <Form.Check
          inline
          type='radio'
          id='responsiblePerson.option.disabled'
          name='responsiblePerson.option.disabled'
          label={t('assetTypes:optionDisabled')}
          checked={checkConfigOption(
            'disabled',
            defaultConfiguration.responsiblePerson.option
          )}
          onChange={updateInputFields}
        />
      </Form.Group>
      <Form.Group className='mb-3'>
        <Form.Label className='d-block ps-1'>
          {t('assetTypes:timeSpan')}
        </Form.Label>
        <Form.Check
          inline
          type='radio'
          id='timeSpan.option.mandatory'
          name='timeSpan.option.mandatory'
          label={t('assetTypes:optionMandatory')}
          checked={checkConfigOption(
            'mandatory',
            defaultConfiguration.timeSpan.option
          )}
          onChange={updateInputFields}
        />
        <Form.Check
          inline
          type='radio'
          id='timeSpan.option.enabled'
          name='timeSpan.option.enabled'
          label={t('assetTypes:optionEnabled')}
          checked={checkConfigOption(
            'enabled',
            defaultConfiguration.timeSpan.option
          )}
          onChange={updateInputFields}
        />
        <Form.Check
          inline
          type='radio'
          id='timeSpan.option.disabled'
          name='timeSpan.option.disabled'
          label={t('assetTypes:optionDisabled')}
          checked={checkConfigOption(
            'disabled',
            defaultConfiguration.timeSpan.option
          )}
          onChange={updateInputFields}
        />
      </Form.Group>
      <Form.Group className='mb-3'>
        <Form.Check
          type='checkbox'
          id='timeSpan.autogenerateReturns'
          label={t('assetTypes:autogenerateReturns')}
          checked={defaultConfiguration.timeSpan.autogenerateReturns}
          onChange={updateInputFields}
        />
      </Form.Group>
      <Form.Group className='mb-3'>
        <Form.Label className='d-block ps-1'>
          {t('assetTypes:commentField')}
        </Form.Label>
        <Form.Check
          inline
          type='radio'
          id='comment.option.mandatory'
          name='comment.option.mandatory'
          label={t('assetTypes:optionMandatory')}
          checked={checkConfigOption(
            'mandatory',
            defaultConfiguration.comment.option
          )}
          onChange={updateInputFields}
        />
        <Form.Check
          inline
          type='radio'
          id='comment.option.enabled'
          name='comment.option.enabled'
          label={t('assetTypes:optionEnabled')}
          checked={checkConfigOption(
            'enabled',
            defaultConfiguration.comment.option
          )}
          onChange={updateInputFields}
        />
        <Form.Check
          inline
          type='radio'
          id='comment.option.disabled'
          name='comment.option.disabled'
          label={t('assetTypes:optionDisabled')}
          checked={checkConfigOption(
            'disabled',
            defaultConfiguration.comment.option
          )}
          onChange={updateInputFields}
        />
      </Form.Group>
    </>
  )
}

export default AssetTypeDefaultForm
